<template>
  <div class="chat-fixed d-flex align-end" v-if="peerJSLoaded">
    <ChatBox
      v-for="(friendId, index) in openedChatBoxes"
      :friendId="friendId"
      :isTabActive="isTabActive"
      :key="index"
      :ref="'chatBox' + friendId"
    />
    <div class="chat-more mr-3" v-if="showListFriend">
      <v-card width="250px" height="450px" :elevation="4">
        <v-list class="pa-2" v-if="friends.length !== 0">

            <v-list-item
              dense class="px-2 pointer"
              :class="{ 'grey lighten-4': !friend.readMessage }"
              v-for="(friend, index) in friends" :key="index"
              v-if="friend.status !== FRIEND_STATUS_BLOCKED_STRANGER
                    && friend.status !== FRIEND_STATUS_DENIED
                    && friend.status !== FRIEND_STATUS_BLOCKING_STRANGER"
              @click="openChatBox(friend.user.id)"
            >

              <v-list-item-avatar
                class="mr-2" width="35" height="35" min-width="35"
              >
                <v-img :src="avatarUrl(friend.user.picture)"></v-img>
              </v-list-item-avatar>

              <span v-if="friend.user.isOnline">
                <v-badge bordered color="green" offset-y="2" offset-x="15" dot>
                  <v-icon size="18">fas fa-dot</v-icon>
                </v-badge>
              </span>
              <v-hover
                v-slot="{ hover }"
                open-delay="200"
              >
                <v-list-item-content>
                  <v-list-item-title v-html="friend.user.name" />
                  <v-list-item-subtitle>
                    {{ friend.lastMessageTranslated }}
                  </v-list-item-subtitle>
                  <ChatMenuChatList
                    :friend="friend"
                    v-show="hover"
                  />
                </v-list-item-content>
              </v-hover>

            </v-list-item>

        </v-list>
        <div v-else class="text-center my-3">
          <translate>No data available</translate>
        </div>
      </v-card>
    </div>
    <div class="chat-list">
      <ScrollTop :fixed="false"/>
      <v-list>
        <template v-for="(friend, index) in activeFriends">
          <v-list-item v-if="friend && friendExist(friend.user.id)" :key="index" class="px-0 pointer">
            <v-list-item-avatar
              class="ma-0 mb-2"
              :class="{ 'blob-pulse': friend.notify }"
              width="50"
              height="50"
              @click="openChatBox(friend.user.id)"
            >
              <v-img :src="avatarUrl(friend.user.picture)"></v-img>
            </v-list-item-avatar>
            <v-btn
              icon
              x-small
              class="chat-list-close"
              color="error"
              @click="removeActiveChat(friend.user.id)"
            >
              <v-icon size="12">fas fa-xmark</v-icon>
            </v-btn>
            <span v-if="friend.user.isOnline">
              <v-badge bordered color="green" offset-y="2" offset-x="12" icon>
                <v-icon size="18">fas fa-dot</v-icon>
              </v-badge>
            </span>
          </v-list-item>
        </template>
      </v-list>
      <v-btn
        color="#fff"
        fab small size="40"
        :class="{ 'blob-pulse': false }"
        class="friendListBtn"
        ref="friends-list"
        @click="toggleListFriend"
      >
        <v-icon class="primary--text" size="21">far fa-message-dots</v-icon>
      </v-btn>
    </div>
    <VideoCall ref="videoCall"/>
  </div>
</template>

<script>
import ChatService from "@/services/ChatService";
import MultiPeer from "@/plugins/multi-peer";
import ChatBox from "@/components/Chat/ChatBox";
import ChatMenuChatList from "@/components/Chat/ChatMenuChatList";
import VideoCall from "@/components/Chat/VideoCall";
import ScrollTop from "@/components/Buttons/ScrollTop";
export default {
  components: {
    ChatBox,
    ChatMenuChatList,
    VideoCall,
    ScrollTop
  },
  data() {
    return {
      getFriendInterval: null,
      peerJS: null,
      peerJSLoaded: false,
      dataQueue: {},
      myPeerId: null,
      isTabActive: true,
      componentFriends: []
    };
  },
  computed: {
    friends: {
      get() {
        if(this.isTabActive) {
          this.componentFriends = this.$store.state.chat.friends
        }
        if(this.componentFriends.length !== 0) {
          const language = this.$language.current
          this.componentFriends.map(item => {
            if(item.lastMessage) {
              const NoTranslatePlease = item.lastMessage
              item.lastMessageTranslated = this.$gettext(NoTranslatePlease)
            }
          })
        }
        return this.componentFriends;
      },
      set(value) {
        return this.$store.state.chat.friends = value;
      }
    },
    openedChatBoxes() {
      return this.$store.state.chat.openedChatBoxes.filter(id => {
        return this.friendExist(id)
      })
    },
    showListFriend() {
      return this.$store.state.chat.showListFriend === 'true';
    },
    activeFriends() {
      return this.$store.state.chat.activeChats.map(friendId => {
        return this.friends.find(friend => friend.user.id === friendId)
      })
    }
  },
  watch: {
    openedChatBoxes: {
      handler(val) {
        if(!this.$vuetify.breakpoint.smAndDown) return
        const elem = document.getElementById("app");
        if(!val || val.length === 0) {
          elem.setAttribute("style","touch-action: auto; -ms-touch-action: auto; overflow: auto;");
          document.documentElement.classList.remove("chatbox-open");
        } else {
          console.log('at, chat wrapper comp, there are open chatbox, add scroll to body')
          elem.setAttribute("style","touch-action: none; -ms-touch-action: none; overflow: hidden;");
          document.documentElement.classList.add("chatbox-open");
        }
      },
      immediate: true
    }
  },
  methods: {
    friendExist(id) {
      return this.friends.find(
        friend => friend.user.id == id
                  && friend.status !== FRIEND_STATUS_BLOCKED_STRANGER
                  && friend.status !== FRIEND_STATUS_BLOCKING_STRANGER
      )
    },
    toggleListFriend() {
      this.$store.commit('chat/commitShowListFriend', this.showListFriend ? 'false' : 'true')
    },
    async openChatBox(userId) {
      this.$store.dispatch("chat/openChatBox", userId);
    },
    removeActiveChat(userId) {
      this.$store.dispatch("chat/removeActiveChat", userId);
    },
    async sendData(data, friendUserId, retry = 0, failedKeys = []) {
      const _this = this
      if(data) {
        if(!this.dataQueue[friendUserId] || !this.dataQueue[friendUserId].queue) {
          this.dataQueue[friendUserId] = {
            queue: [],
            inProgress: false
          }
        }
        this.dataQueue[friendUserId].queue.push(data);
      }
      if(this.dataQueue[friendUserId].inProgress) {
        return
      }
      this.dataQueue[friendUserId].inProgress = true

      retry ++

      if(retry > 4) {
        this.dataQueue[friendUserId] = {}
        return
      }
      let remotePeerId = null
      const friend = this.friends.find(friend => friend.user.id == friendUserId)
      if(friend && friend.key) {
        remotePeerId = friend.key
      } else {
        const keyResult = await ChatService.getKeyChat(friendUserId);
        remotePeerId = keyResult.key
      }
      if(!remotePeerId) {
        this.dataQueue[friendUserId] = {}
        return true
      }
      if(!this.peerJS) {
        this.peerJS = new MultiPeer();
      }
      const connection = this.peerJS.connections[friendUserId];
      if(connection && connection.open) {
        connection.send(this.dataQueue[friendUserId].queue)
        this.dataQueue[friendUserId] = {}
        return true
      }

      try {
        const result = await this.peerJS.connectPeer(
                          remotePeerId,
                          friendUserId,
                          this.$store.state.auth.userId,
                          this.dataQueue[friendUserId].queue
                        )
        this.dataQueue[friendUserId] = {}
      } catch (error) {
        delete(this.peerJS.connections[friendUserId]);
        if(friend) {
          failedKeys.push(remotePeerId)
          const keyResult = await ChatService.getKeyChatRetry(friendUserId, failedKeys);
          if(friend.key && keyResult.key && friend.key !== keyResult.key) {
            friend.key = keyResult.key
          }
        }
        this.dataQueue[friendUserId].inProgress = false
        return this.sendData([], friendUserId, retry, failedKeys)
      }
      return true
    },
    async handleData(event) {
      const result = event.detail || {};
      result.data.forEach(data => {
        if (data.type == 'commitFriend') {
          console.log('request friend incoming', data.payload)
          this.$store.commit('chat/commitFriend', data.payload)
          this.$store.dispatch("chat/openChatBox", data.payload.user.id);
        } else if (data.type == 'denyFriend') {
          this.$store.dispatch('chat/removeActiveChat', data.payload.user.id)
          this.$store.commit('chat/commitFriend', data.payload)
        } else if (data.type == 'blockFriend') {
          this.$store.commit('chat/commitFriend', data.payload)
        } else if (data.type == 'removeFriend') {
          const friendUserId =  1*data.payload
          this.$store.dispatch("chat/removeActiveChat", friendUserId);
          this.$store.commit('chat/removeFriend', friendUserId)
        } else if (data.type == 'message') {
          const friend = this.friendExist(data.payload.friendId);
          if(!friend || friend.status === FRIEND_STATUS_BLOCKING) return
          this.$store.commit('chat/commitMessage', data.payload)

          const chatWrapper = this.$store.state.toggle.ChatFixedBottom
          const chatBox = chatWrapper.$refs['chatBox' + data.payload.friendId]
          if(chatBox) {
            const message = data.payload.message
            const key = message[MESSAGE_OWNER_INDEX] + message[MESSAGE_TIME_INDEX]
            this.$set(chatBox[0].newMessages, key, message)
            chatBox[0].$nextTick(() => {
              chatBox[0].scrollToBottom();
            })
          }
        } else if (data.type == 'updateMessage') {
          this.$store.commit('chat/commitMessage', data.payload)
          const chatWrapper = this.$store.state.toggle.ChatFixedBottom
          const chatBox = chatWrapper.$refs['chatBox' + data.payload.friendId]
          if(chatBox) {
            chatBox[0].updateNewMessages(data.payload.messages)
            if(data.type == 'updateMessage') {
              chatBox[0].$nextTick(() => {
                chatBox[0].scrollToBottom();
              })
            }
          }
        } else if (data.type == 'deleteMessage') {
          this.$store.commit('chat/commitMessage', data.payload)
          const chatWrapper = this.$store.state.toggle.ChatFixedBottom
          const chatBox = chatWrapper.$refs['chatBox' + data.payload.friendId]
          if(chatBox) {
            const message = data.payload.messages[0];
            message[MESSAGE_OWNER_INDEX] = 'partner'
            chatBox[0].handleDeleteMessage(message)
          }
        }
      })

    }

  },
  beforeDestroy() {
    clearInterval(this.getFriendInterval)
    document.removeEventListener("peerReceiveData", this.handleData);

  },
  async mounted() {
    const _this = this
    clearInterval(this.getFriendInterval);
    this.getFriendInterval = setInterval(() => {
      const friendsDate = _this.$store.state.chat.friendsDate
      if(!friendsDate) {
        _this.$store.dispatch('chat/getFriends')
      }
      const now = Date.now();
      if((now - friendsDate) > 30000 && _this.isTabActive) {
        _this.$store.dispatch('chat/getFriends')
      }
    }, 1000)

    this.peerJS = new MultiPeer();
    if (this.peerJS.peer.open) {
      this.peerJSLoaded = true;
    }
    this.peerJS.peer.on("open", function (peerId) {
      _this.peerJSLoaded = true;
      _this.myPeerId = peerId
      ChatService.addKeyChat(peerId);
    });
    const apiUrl = process.env.VUE_APP_API_URL
                    ? process.env.VUE_APP_API_URL
                    : ('https://' + location.host + '/api');
    document.addEventListener("peerReceiveData", this.handleData);
    window.addEventListener('visibilitychange', () => {
      if (window.visibilityState === 'hidden') {
        navigator.sendBeacon(apiUrl + '/chat/delete-key/' + _this.myPeerId);
      }
    });

    window.onbeforeunload = () => {
      navigator.sendBeacon(apiUrl + '/chat/delete-key/' + _this.myPeerId);
    }
    window.onfocus = function () {
      _this.isTabActive = true;
    };

    window.onblur = function () {
      _this.isTabActive = false;
    };
  },
};
</script>